export * from "./control-table.models";
export * from "./control-table.service";
export * from "./control-table-shell.component";
export * from "./control-table.component";
export * from "./control-table-admin.component";
export * from "./control-table-order-modal.component";
export * from "./control-table-depth-modal.component";



// WEBPACK FOOTER //
// ./app/insa-components/insa-control-table/index.ts